import React from 'react';
import { CheckIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
import { bonuses, checkoutAssurances, pricing, systemStack } from '../data/bonuses';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="offer" className="scroll-mt-20 bg-brand px-4 py-12 md:py-16" aria-labelledby="offer-title" data-id="element-140" data-mp="3iucmkabjz5z3">
      <div className="mx-auto max-w-2xl" data-id="element-141" data-mp="3npjk10e8befk">
        <h2 id="offer-title" className="text-center font-display text-xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-142" data-mp="fbje2bxmt7bs">
          Get the Complete Injury Rehabilitation Bundle <span className="text-navy" data-id="element-143" data-mp="6a34u7ijzb95">today</span>
        </h2>

        <article className="mt-8 rounded-3xl border-2 border-brand-light bg-white p-6 shadow-2xl md:p-8" data-id="element-144" data-mp="acpz0f2p589i">
          <div className="flex items-center justify-between gap-3" data-id="element-145" data-mp="2r1lnzt6ed56o">
            <p className="font-display text-sm font-black uppercase text-navy md:text-base" data-id="element-146" data-mp="2r3gedn0ftpi5">Complete 5-volume system</p>
            <p className="shrink-0 text-right text-[10px] font-bold uppercase text-steel" data-id="element-147" data-mp="2fnkux8a931od">
              Individual value:{' '}
              <span className="text-sm font-black line-through decoration-red-600 decoration-2" data-id="element-148" data-mp="2apayyvgpbx1p">
                ${pricing.systemValue} USD
              </span>
            </p>
          </div>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-149" data-mp="2km5quvigyz70">
            {systemStack.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-navy" data-id="element-150" data-mp="2ylopmxpe4y6n">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-151" data-mp="2to5c600iopfr" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 font-display text-xs font-black uppercase tracking-wider text-brand md:text-sm" data-id="element-152" data-mp="38e2sjts7gaue">
            Plus 5 bonuses:
          </p>
          <ul className="mt-1 divide-y divide-navy/10" data-id="element-153" data-mp="3hdzkc49w5pto">
            {bonuses.map(bonus => <li key={bonus.number} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-154" data-mp="3cewguo9k7rnt">
                <span className="font-semibold text-navy" data-id="element-155" data-mp="2a1qgprttkom1">{bonus.name}</span>
                <span className="flex shrink-0 items-center gap-2" data-id="element-156" data-mp="2eyqpiai205gu">
                  <span className="font-bold text-steel line-through decoration-red-600 decoration-2" data-id="element-157" data-mp="2j156sq62qx60">
                    ${bonus.value} USD
                  </span>
                  <span className="text-xs font-black uppercase text-brand" data-id="element-158" data-mp="2nt51o47aezvq">Free</span>
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-159" data-mp="2xprkkng1zgv4">
              <span className="font-display text-xs font-black uppercase text-navy" data-id="element-160" data-mp="2xruidtng6eae">Total bonus value</span>
              <span className="shrink-0 font-black text-steel line-through decoration-red-600 decoration-2" data-id="element-161" data-mp="36qpoz6uelqe8">
                ${pricing.bonusValue} USD
              </span>
            </li>
          </ul>

          <div className="mt-3 flex items-center justify-between gap-4 rounded-xl bg-canvas px-4 py-3" data-id="element-162" data-mp="1ccf2v6571ac5">
            <span className="font-display text-xs font-black uppercase text-navy md:text-sm" data-id="element-163" data-mp="14sw3vqfk16hx">Total individual value</span>
            <span className="font-display text-lg font-black text-steel line-through decoration-red-600 decoration-[3px]" data-id="element-164" data-mp="101ec9szf8i9m">
              ${pricing.totalValue} USD
            </span>
          </div>

          <div className="mt-8 text-center" data-id="element-165" data-mp="r2ka7n3bmzoo">
            <p className="text-[11px] font-black uppercase tracking-[.2em] text-brand md:text-xs" data-id="element-166" data-mp="qzobhwjng6z6">
              Today's promotional launch price
            </p>
            <p className="mt-2 font-display text-6xl font-black leading-none text-navy md:text-7xl" data-id="element-167" data-mp="1iu013tbwv8kp">
              ${pricing.price} <span className="text-2xl md:text-3xl" data-id="element-168" data-mp="1epsf43wu86q6">USD</span>
            </p>
            <p className="mt-3 font-display text-xs font-black uppercase tracking-wider text-brand md:text-sm" data-id="element-169" data-mp="19r7e429rhj0o">
              One-time payment
            </p>
            <p className="mt-2 inline-flex rounded-md bg-brand-light/20 px-3 py-1.5 text-xs font-extrabold uppercase text-brand-dark" data-id="element-170" data-mp="3uihmq2oygjq6">
              You save ${pricing.savings} USD
            </p>
            <div className="mt-6" data-id="element-171" data-mp="1r0i0qkcdbzjj">
              <Button href={checkoutUrl} size="lg" fullWidth data-id="element-172" data-mp="1r1jn3kyu48gk">
                Get instant access — ${pricing.price}
              </Button>
            </div>
            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-173" data-mp="1haoori8bdier">
              {checkoutAssurances.map(item => <li key={item} className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase text-steel" data-id="element-174" data-mp="250199e93dcwd">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-175" data-mp="29y2rjwyp186s" />
                  {item}
                </li>)}
            </ul>
          </div>
        </article>
      </div>
    </section>;
}